export const notificationTypes = {
  availabilityUpdatedByEmployee: 'availabilityupdatedbyemployee',
  availabilityUpdatedByApprover: 'availabilityupdatedbyapprover',
} as const;

export const normalizeNotificationType = (value: string) =>
  value.replace(/[^a-z0-9]/gi, '').toLowerCase();
